(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('ExternalResource', ExternalResource);

    ExternalResource.$inject = ['$resource', 'DateUtils'];

    function ExternalResource ($resource, DateUtils) {
        var resourceUrl =  'api/external-resources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.loadTime = DateUtils.convertDateTimeFromServer(data.loadTime);
                        data.lastDownload = DateUtils.convertDateTimeFromServer(data.lastDownload);
                        data.lastSuccessProcessing = DateUtils.convertDateTimeFromServer(data.lastSuccessProcessing);
                    }
                    return data;
                }
            },
            'run': { method:'POST', url: 'api/external-resources/run/:id' },
            'update': { method:'PUT' }
        });
    }
})();
